module.exports = __webpack_public_path__ + "img/sisley-logo_black.c8989279.svg";